import { useState, useEffect, useCallback } from "react";

/**
 * Hook to track online/offline status
 * Uses the browser's navigator.onLine and online/offline events
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() => {
    // Default to true if navigator is not available (SSR)
    if (typeof navigator === "undefined") return true;
    return navigator.onLine;
  });

  const handleOnline = useCallback(() => {
    setIsOnline(true);
  }, []);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
  }, []);

  useEffect(() => {
    // Add event listeners
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Update status on mount (in case it changed during SSR hydration)
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return {
    isOnline,
    isOffline: !isOnline,
  };
}

export default useOnlineStatus;
